/**
 * Constructor :
 * - model : global model
 * - options :
 *     	- filtersDisabled : disable filters
 * 		- automaticPlacingDisabled : disable automatic placing
 */
fx.ns("desktop.poster", class PosterPhotosPanel extends desktop.common.panels.PhotosPanel {
    
	constructor(model, options)
	{
		super(model, options);
	}

	addPhoto(e)
	{
        this.data.event("selectphotos", this.model.creation.filteredPhoto);
	}

    
		
});
